import { render, staticRenderFns } from "./DashboardEquipamentosTravados.vue?vue&type=template&id=4cddaec4&scoped=true&"
import script from "./DashboardEquipamentosTravados.vue?vue&type=script&lang=js&"
export * from "./DashboardEquipamentosTravados.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEquipamentosTravados.vue?vue&type=style&index=0&id=4cddaec4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cddaec4",
  null
  
)

export default component.exports